function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperienceStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.37 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m62 52.438-.436-1.838a.62.62 0 0 1 .2-.6l1.436-1.239a.587.587 0 0 0-.334-1.037L61 47.557a.644.644 0 0 1-.5-.368l-.735-1.738a.593.593 0 0 0-1.1 0l-.735 1.738a.644.644 0 0 1-.5.368l-1.905.167a.587.587 0 0 0-.334 1.037L56.617 50a.647.647 0 0 1 .2.6l-.435 1.839a.593.593 0 0 0 .9.635l1.6-.969a.705.705 0 0 1 .635 0l1.6.969a.577.577 0 0 0 .883-.636z",
    transform: "translate(-49.004 -45.075)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.565 70.525-1.872-.167a.644.644 0 0 1-.5-.368l-.769-1.738a.593.593 0 0 0-1.1 0l-.735 1.738a.644.644 0 0 1-.5.368l-1.872.167a.587.587 0 0 0-.334 1.037l1.43 1.238a.647.647 0 0 1 .2.6l-.435 1.838a.593.593 0 0 0 .9.635l1.6-.969a.705.705 0 0 1 .635 0l1.6.969a.6.6 0 0 0 .9-.635l-.42-1.838a.62.62 0 0 1 .2-.6l1.438-1.237a.61.61 0 0 0-.367-1.037z",
    transform: "translate(-37.663 -59.973)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 71.559a.587.587 0 0 0-.334-1.037l-1.872-.167a.644.644 0 0 1-.5-.368l-.768-1.737a.593.593 0 0 0-1.1 0l-.735 1.738a.644.644 0 0 1-.5.368l-1.872.167a.587.587 0 0 0-.334 1.037l1.429 1.24a.647.647 0 0 1 .2.6l-.435 1.839a.593.593 0 0 0 .9.635l1.6-.969a.705.705 0 0 1 .635 0l1.6.969a.6.6 0 0 0 .9-.635l-.467-1.84a.62.62 0 0 1 .2-.6z",
    transform: "translate(-60.34 -59.972)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceStars);
export default __webpack_public_path__ + "static/media/experience-stars.09ca2c07.svg";
export { ForwardRef as ReactComponent };